module.exports = __webpack_public_path__ + "img/card11.71d09011.jpg";